/**
 * The palette for schedules, labels and lanes.
 *
 * Ten hues, spread around the wheel and all at least 4.8:1 against white — the
 * swatches carry a white check when selected, and the same colours end up as
 * thin edges on a pale week grid, where a light tint would simply disappear.
 * Slate sits at the end as the deliberate "no particular category" choice.
 */
export const COLOR_PRESETS = [
    '#DC2626',
    '#C2410C',
    '#A16207',
    '#4D7C0F',
    '#15803D',
    '#0F766E',
    '#1D4ED8',
    '#6D28D9',
    '#BE185D',
    '#334155'
];

/** What a new group, column or tag starts on. Blue reads as unassigned; red does not. */
export const DEFAULT_PRESET = '#1D4ED8';

export const isHexColor = (value: string) => /^#[0-9a-f]{6}$/i.test(value);
export const sameColor = (a: string, b: string) => a.toLowerCase() === b.toLowerCase();
export const isPreset = (color: string) => COLOR_PRESETS.some((preset) => sameColor(preset, color));
